<template>
  <div class="heading-container">
    <div class="text-container">
      <img
        :src="icon"
        class="text-icon"
        :alt="iconAlt">
      <h2 class="text">{{title}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      required: true,
    },
    iconAlt: {
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.heading-container {
  .text-container {
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    .search-icon, .text-icon {
      width: 40px;
      margin-right: 10px;
    }
  }
  &::after {
    display: block;
    content: ' ';
    width: 100%;
    height: 2px;
    background: $gray-600;
  }
}

@media screen and (max-width: 660px) {
  .heading-container {
    .text-container {
      align-items: center;
      .text {
        font-size: $h4-font-size;
        margin-bottom: 0;
      }
    }
  }
}
</style>
